import { slerp1d } from "../util/mathutil";
import { debugBoundingBoxes } from "../constants";

// @ts-ignore - Duplicate identifier from CommonJS pattern
export class Pawn {
  rootObj: any;
  direction: number;
  boundingBox: any;
  boundingOffset: any;
  boundingBoxObj: any;
  boundingBonePosition: any;
  skel?: any;

  constructor() {
    this.rootObj = new THREE.Object3D();
    this.rootObj.userData.owner = this;
    this.direction = 0;
    this.boundingBox = new THREE.Box3();
    this.boundingOffset = new THREE.Vector3();
    this.boundingBonePosition = new THREE.Vector3();
    this.boundingBoxObj = new THREE.Mesh(
      new THREE.BoxGeometry(1, 1, 1),
      new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: true })
    );
    this.boundingBoxObj.visible = debugBoundingBoxes;
    this.rootObj.add(this.boundingBoxObj);
  }

  _addBoundsGeometry(skinnedMesh: any) {
    const v1 = new THREE.Vector3();

    const geometry = skinnedMesh.geometry;
    const positions = geometry.attributes['position'].array;

    for (let i = 0, il = positions.length; i < il; i += 3) {
      v1.set(positions[i], positions[i + 1], positions[i + 2]);
      this.boundingBox.expandByPoint(v1);
    }

    this.boundingBox.getSize(this.boundingBoxObj.scale);
    this.boundingBox.getCenter(this.boundingOffset);
  }

  setPosition(pos: any) {
    this.rootObj.position.copy(pos);
  }

  setDirection(radians: number) {
    this.direction = radians;
  }

  update(delta: number) {
    const dirStep = (Math.PI * 3) * delta;
    const deltaDir = slerp1d(this.direction, this.rootObj.rotation.z);

    if (deltaDir > dirStep || deltaDir < -dirStep) {
      if (deltaDir < 0) {
        this.rootObj.rotation.z -= dirStep;
      } else {
        this.rootObj.rotation.z += dirStep;
      }
    } else {
      this.rootObj.rotation.z = this.direction;
    }

    if (this.skel && this.skel.bones.length > 0) {
      // boneMatrices are skinning offsets, not world positions. Use the
      // actual root bone so the pick box stays with the visible model.
      this.skel.bones[0].getWorldPosition(this.boundingBonePosition);
      this.rootObj.worldToLocal(this.boundingBonePosition);
      this.boundingBoxObj.position.copy(this.boundingBonePosition).add(this.boundingOffset);
    }
  }
}
